export default {
  state: {
    colors: [
      '#2ecc71',
      '#f39c12',
      '#e74c3c',
      '#c0392b',
      '#bdc3c7',
      '#7f8c8d',
      '#2c3e50'
    ]
  },
  actions: {
    async suggestAddress({dispatch}, query) {
      return await dispatch('apiQuery', {method:'/address/suggest', body: {query}})
    },
    async deliveryZone({dispatch}, coordinates) {
      return await dispatch('apiQuery', {method:'/address/delivery_zone', body: coordinates})
    }
  },
  getters: {
    zone_colors(state) {
      return state.colors
    }
  }
}